import { useState, useCallback } from "react";
import axios from "axios";
import Cookies from "js-cookie";

const useDelete = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const deleteData = useCallback(async (url, onSuccess) => {
    setIsLoading(true);
    setErrorMessage(null);
    setSuccessMessage(null);

    try {
      const accessToken = Cookies.get("access_token");
      const response = await axios.delete(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "X-CLIENT-API-KEY": process.env.REACT_APP_API_KEY,
        },
      });

      if (response.status !== 200 && response.status !== 204) {
        throw new Error("Failed to delete data.");
      }

      setSuccessMessage("Data deleted successfully.");
      setIsLoading(false);

      if (onSuccess) {
        onSuccess();
      }

      return response.data;
    } catch (error) {
      if (error.response) {
        setErrorMessage(error.response.data);
      } else if (error.request) {
        setErrorMessage("No response received from the server.");
      } else {
        setErrorMessage(error.message);
      }
      setIsLoading(false);
      throw error;
    }
  }, []);

  return { deleteData, isLoading, errorMessage, successMessage };
};

export default useDelete;
